// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pdf-preview {
  position: relative;
}
.pdf-preview .pdf-iframe {
  width: 100%;
  height: 500px;
}
.pdf-preview .share-container {
  position: absolute;
  bottom: -3.9%;
  right: 10.5%;
  z-index: 100;
}
.pdf-preview .share-menu {
  position: absolute;
  bottom: 150%;
  right: 0;
  background-color: white;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  min-width: 120px;
}
.pdf-preview .share-menu button {
  display: block;
  width: 100%;
  padding: 8px 10px;
  text-align: left;
  background: none;
  border: none;
  cursor: pointer;
}
.pdf-preview .share-menu button:hover {
  background-color: rgb(242, 246, 252);
  border-radius: 5px;
}
.pdf-preview .share-btn {
  margin-top: 2.5vh;
}
@media screen and (max-width: 1280px) and (max-height: 900px) {
  .pdf-preview .share-container {
    bottom: calc(1rem - 2.3em);
    right: 11%;
  }
}
@media screen and (max-width: 4000px) and (max-height: 1200px) {
  .pdf-preview .share-container {
    bottom: calc(1rem - 2.3em);
    right: 11.5%;
  }
}
@media screen and (max-width: 4000px) and (min-height: 1300px) {
  .pdf-preview .share-container {
    bottom: calc(1rem - 2.3em);
    right: 11.5%;
  }
}

.pdf-container {
  position: relative;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/Components/KP/kp-f/kpFinTable/PdfPrevievModal.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;AACE;EACE,WAAA;EACA,aAAA;AACJ;AAEE;EACE,kBAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;AAAJ;AAGE;EACE,kBAAA;EACA,YAAA;EACA,QAAA;EACA,uBAAA;EACA,kBAAA;EACA,uCAAA;EACA,gBAAA;AADJ;AAGI;EACE,cAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;AADN;AAGM;EACE,oCAAA;EACA,kBAAA;AADR;AAME;EACE,iBAAA;AAJJ;AAOE;EACE;IAEE,0BAAA;IACA,UAAA;EANJ;AACF;AASE;EACE;IAEE,0BAAA;IACA,YAAA;EARJ;AACF;AAWE;EACE;IAEE,0BAAA;IACA,YAAA;EAVJ;AACF;;AAcA;EACE,kBAAA;EACA,WAAA;AAXF","sourcesContent":[".pdf-preview {\n  position: relative;\n\n  .pdf-iframe {\n    width: 100%;\n    height: 500px;\n  }\n\n  .share-container {\n    position: absolute;\n    bottom: -3.9%;\n    right: 10.5%;\n    z-index: 100;\n  }\n\n  .share-menu {\n    position: absolute;\n    bottom: 150%;\n    right: 0;\n    background-color: white;\n    border-radius: 5px;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n    min-width: 120px;\n\n    button {\n      display: block;\n      width: 100%;\n      padding: 8px 10px;\n      text-align: left;\n      background: none;\n      border: none;\n      cursor: pointer;\n\n      &:hover {\n        background-color: rgb(242, 246, 252);\n        border-radius: 5px;\n      }\n    }\n  }\n\n  .share-btn {\n    margin-top: 2.5vh;\n  }\n\n  @media screen and (max-width: 1280px) and (max-height: 900px) {\n    .share-container {\n      // bottom: -1.7%;\n      bottom: calc(1rem - 2.3em);\n      right: 11%;\n    }\n  }\n\n  @media screen and (max-width: 4000px) and (max-height: 1200px) {\n    .share-container {\n      // bottom: -3.7%;\n      bottom: calc(1rem - 2.3em);\n      right: 11.5%;\n    }\n  }\n\n  @media screen and (max-width: 4000px) and (min-height: 1300px) {\n    .share-container {\n      // bottom: -2%;\n      bottom: calc(1rem - 2.3em);\n      right: 11.5%;\n    }\n  }\n}\n\n.pdf-container {\n  position: relative;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
